export default __webpack_public_path__ + "static/collective-ai-ca5b687eea1aa7bdd034cf704d391eced67e4225f42b0a61cd275f4108bf392b.png";